import React , {FC, useEffect} from "react";
import { ButtonProps} from "./Button.types";
import  './Button.css'
import ButtonService from "../../services/ButtonService";
/*
React.useEffect(()=> {
    
},[])*/
const buttonClick = () =>{
    const ff = new ButtonService();
    
    ff.displayBaseUrl(); 
}
const Button: FC<ButtonProps> = ({type,text,onClick,content}) => {
    return (
        <button type="button" className={`button Button-${content?.type}`} onClick={onClick}>{content?.text}</button>

    )
};

export default Button;